import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { BusAlertToggleRequest } from "../shared/BusAlertToggleRequest";
import { DataService_BusTrackerMap } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-bus-alert-table",
	templateUrl: "./bus-alert-table.component.html",
	styleUrls: ["./bus-alert-table.component.css"],
})
export class BusAlertTableComponent implements OnInit {
	constructor(
		private userService: UserService,
		private mapService: DataService_BusTrackerMap,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadBusAlertTxn();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() RefreshAlerts: EventEmitter<any> = new EventEmitter();

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedBusAlertTxns: any;
	lstBusAlertTxn: any = [];

	//Filter lists
	lstAlertTypeCD: any = [];
	lstAlertTypeDesc: any = [];
	lstSeverityDesc: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols1: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "AlertTypeCD", header: "Type Code" },
		{ field: "AlertTypeDesc", header: "Type Description" },
		{ field: "SeverityDesc", header: "Severity" },
		{ field: "StartDTDesc", header: "Start" },
		{ field: "EndDTDesc", header: "End" },
		{ field: "Comments", header: "Comments" },
		// { field: 'ActiveDesc', header: 'Active' },
		// { field: 'BusNbr', header: 'Bus' },
		// { field: 'PersonName', header: 'Created By' },
	];

	cols2: any = [
		{ field: "BusNbr", header: "Bus" },
		{ field: "PersonName", header: "Created By" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadBusAlertTxn() {
		this.errorMessage = "";

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}

		this.loading = true;

		var result = this.mapService.BusAlertSelectList(fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstBusAlertTxn = response;

				//Load Data Filter Lists
				this.lstAlertTypeCD = Array.from(new Set(this.lstBusAlertTxn.map((item: any) => item.AlertTypeCD))).sort();
				this.lstAlertTypeDesc = Array.from(new Set(this.lstBusAlertTxn.map((item: any) => item.AlertTypeDesc))).sort();
				this.lstSeverityDesc = Array.from(new Set(this.lstBusAlertTxn.map((item: any) => item.SeverityDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstBusAlertTxn.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadBusAlertTxn();
	}

	//Custom Button Methods

	onActivate() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		if (this.SelectedBusAlertTxns.length == 0) {
			this.errorMessage = "Select Alerts to Activate";
			return;
		}

		//
		// Create Parms
		//

		var lstIDs: number[] = [];

		for (var z = 0; z < this.SelectedBusAlertTxns.length; z++) {
			var next = this.SelectedBusAlertTxns[z];

			lstIDs = [...lstIDs, next.BusAlertTxnID];
		}

		let parms: BusAlertToggleRequest = {
			lstBusAlertTxnIDs: lstIDs,
		};

		//
		// Call SP
		//
		var result = this.mapService.ActivateBusAlerts(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.SelectedBusAlertTxns = [];
					this.loadBusAlertTxn();
					this.RefreshAlerts.emit(true);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "busalerts",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not activate the alerts",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onDeactivate() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		if (this.SelectedBusAlertTxns.length == 0) {
			this.errorMessage = "Select Alerts to Deactivate";
			return;
		}

		//
		// Create Parms
		//

		var lstIDs: number[] = [];

		for (var z = 0; z < this.SelectedBusAlertTxns.length; z++) {
			var next = this.SelectedBusAlertTxns[z];

			lstIDs = [...lstIDs, next.BusAlertTxnID];
		}

		let parms: BusAlertToggleRequest = {
			lstBusAlertTxnIDs: lstIDs,
		};

		//
		// Call SP
		//
		var result = this.mapService.DeactivateBusAlerts(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.SelectedBusAlertTxns = [];
					this.loadBusAlertTxn();
					this.RefreshAlerts.emit(true);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "busalerts",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not deactivate the alerts",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onStartDateChange(val) {
		this.StartDate = val;

		this.loadBusAlertTxn();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadBusAlertTxn();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
		// this.SelectedBusAlertTxn = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		// this.SelectedBusAlertTxn = null;
	}
	onRowDblClick(BusAlertTxn) {
		this.errorMessage = "";
		// this.SelectedBusAlertTxn = BusAlertTxn;
		// this.onEditBusAlertTxn();
	}
	////////////////////////////////////////////
}
